import * as actionTypes from '../actionTypes';

export const resetBankScrapingResult = () => ({
  type: actionTypes.RESET_BANK_SCRAPING_RESULT,
});
